import styled from 'styled-components';
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FlexBoxCol, FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { fonts } from '~/src/helpers/font';
import { blockMargin, breakPoints, styleWithBreakPoints } from '~/src/components/LandingBlock/styled';

export const Tariffs = styled.div<{ [key: string]: string }>`
    display: flex;
    width: 100%;

    ${p => blockMargin(p)};     
    ${p => styleWithBreakPoints(p, 'Tariffs')};
`;

export const Container = styled(GridContainer)`
    max-width: 1080px;

    @media (max-width: 790px) {
        padding-left: 16px;
        padding-right: 16px;
    }
`;

export const CardList = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    & > div {
        margin-bottom: 16px;
        margin-right: 8px;
    }
`;

export const Row = styled(FlexBoxRow)`
    width: 100%;
    
    @media (max-width: ${breakPoints.mobile}) {
        width: auto;
    }
`;

export const Col = styled(FlexBoxCol)`
    margin-bottom: 20px;
`;

export const Title = styled.div`
    color: ${COLORS.black};
    font: ${fonts.H2};
    margin-bottom: 30px;
    
    @media (max-width: ${breakPoints.tablet}) {
        font: ${fonts.H2};
    }
    
    @media (max-width: ${breakPoints.mobile}) {
        font: ${fonts.H3};
    }

    ${p => styleWithBreakPoints(p, 'Tariffs.Title')};
`;
